<template>
  <el-dialog class="ticket-dialog dialog-base" :class="{ 'is-mobile': $store.getters.isMobile }"
    :width="$store.getters.isMobile ? '90%' : '640px'" :visible.sync="dialogVisible"
    :modal="!editing">
    <div slot="title" class="ticket-dialog__title">
      <rich-text v-model="titleModel" :editing="editing" theme="snow" :disabled="!editing" />
    </div>
    <div class="ticket-dialog__content" v-loading="loading">
      <div v-if="!loading && !productList.length" class="ticket-dialog__empty">
        {{ $t('siteBuild.lotteryWidget.noData') }}
      </div>
      <div class="ticket-goods-list">
        <div v-for="(product, index) in productList" :key="index" class="ticket-card"
          :style="{ background: cardBackground }">
          <img v-if="product.corner" :src="product.corner" class="card-corner" alt="" />
          <div class="card-title">{{ getProductName(product) }}</div>
          <div class="card-body">
            <div class="card-items">
              <template v-if="product.gift_list">
                <div v-for="(item, iIdx) in product.gift_list" :key="'gift-' + iIdx" class="card-item">
                  <div class="card-item__icon"
                    :class="{ 'has-level': !!item.level_icon }"
                    :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
                    <img :src="item.gift_goods_logo" alt="" />
                  </div>
                  <span class="card-item__num" :style="{ color: moduleColor }">
                    <i class="el-icon-close" />{{ item.num }}
                  </span>
                </div>
              </template>
              <template v-if="product.item_contents">
                <div v-for="(item, iIdx) in product.item_contents" :key="'content-' + iIdx" class="card-item">
                  <div class="card-item__icon"
                    :class="{ 'has-level': !!item.level_icon }"
                    :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
                    <img :src="item.icon" alt="" />
                  </div>
                  <span class="card-item__num" :style="{ color: moduleColor }">
                    <i class="el-icon-close" />{{ item.num }}
                  </span>
                </div>
              </template>
              <template v-if="product.item_contents2">
                <div v-for="(item, iIdx) in product.item_contents2" :key="'content2-' + iIdx" class="card-item">
                  <div class="card-item__icon"
                    :class="{ 'has-level': !!item.level_icon }"
                    :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
                    <img :src="item.icon" alt="" />
                  </div>
                  <span class="card-item__num" :style="{ color: moduleColor }">
                    <i class="el-icon-close" />{{ item.num }}
                  </span>
                </div>
              </template>
              <template v-if="product.system_items">
                <div v-for="(item, iIdx) in product.system_items" :key="'system-' + iIdx" class="card-item">
                  <div class="card-item__icon">
                    <img :src="item.icon" alt="" />
                  </div>
                  <span class="card-item__num" :style="{ color: moduleColor }">
                    <i class="el-icon-close" />{{ item.num }}
                  </span>
                </div>
              </template>
            </div>
            <div class="card-action">
              <button class="buy-btn"
                :style="buttonStyle"
                :disabled="buyLoading || isProductSoldOut(product)"
                @click="handleBuy(product)">
                {{ isProductSoldOut(product) ? $t('siteBuild.lotteryWidget.soldOut') : getPriceText(product) }}
              </button>
              <div v-if="product.is_purchase_limit" class="limit-tag" :style="limitTagStyle">
                Limit {{ product.has_purchase_num }}/{{ product.limit_purchase_num }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import tools, { getLangIdI18n, getTextColor } from '~/utils'
import RichText from '~/components/richText/index.vue'

export default {
  name: 'TicketDialog',
  components: {
    [Dialog.name]: Dialog,
    RichText
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productList: {
      type: Array,
      default() {
        return []
      }
    },
    moduleColor: {
      type: String,
      default: ''
    },
    axelBackground: {
      type: Object,
      default() {
        return {}
      }
    },
    goColor: {
      type: String,
      default: ''
    },
    cardBackground: {
      type: String,
      default: '#f8f9fa'
    },
    loading: {
      type: Boolean,
      default: false
    },
    buyLoading: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    titleModel: {
      get() {
        return this.title
      },
      set(val) {
        this.$emit('update:title', val)
      }
    },
    limitTagStyle() {
      return {
        border: `1px solid ${this.moduleColor || 'currentColor'}`,
        color: this.moduleColor || 'currentColor'
      }
    },
    buttonStyle() {
      return {
        background: getTextColor(this.axelBackground).color,
        color: this.goColor
      }
    }
  },
  methods: {
    getProductName(product) {
      return getLangIdI18n(product.names, this.$store.state.locale.langIdData) || product.name || ''
    },
    isProductSoldOut(product) {
      return product.is_purchase_limit && product.has_purchase_num >= product.limit_purchase_num
    },
    getPriceText(product) {
      const ipInfo = tools.getLangByip(this)
      const priceInfo = tools.getPriceInfo(product.prices_setting, ipInfo, this)
      return `${priceInfo.currencyLabel} ${priceInfo.price || product.default_value}`
    },
    handleBuy(product) {
      this.$emit('buy', product)
      this.$emit('update:buyLoading', true)
    }
  }
}
</script>

<style lang="less">
.ticket-dialog {
  .el-dialog__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__title {
    flex: 1;
    min-width: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .el-dialog__headerbtn {
    position: static;
    flex-shrink: 0;
    margin-left: 16px;
  }

  .el-dialog__body {
    padding: 0;
  }

  &__content {
    padding: 0px;
    max-height: 60vh;
    overflow-y: auto;
    min-height: 120px;
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    font-size: 14px;
    color: #999;
  }

  .ticket-goods-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .ticket-card {
    position: relative;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 12px;

    .card-corner {
      position: absolute;
      top: 0;
      right: 0;
      max-width: 56px;
      max-height: 56px;
      object-fit: contain;
      z-index: 1;
    }

    .card-title {
      font-size: 15px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 12px;
      padding-right: 48px;
      line-height: 1.4;
    }

    .card-body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }

    .card-items {
      display: flex;
      flex-wrap: nowrap;
      gap: 10px;
      overflow-x: auto;
      flex: 1;
      min-width: 0;
      padding-bottom: 2px;

      &::-webkit-scrollbar {
        height: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 2px;
      }

      .card-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;

        &__icon {
          width: 52px;
          height: 52px;
          border-radius: 10px;
          background: #fff;
          border: 1px solid #eee;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          &.has-level {
            border: none;
            border-radius: 0;
            background: var(--level-bg) no-repeat;
            background-color: transparent;
            background-size: 100% 100%;

            img {
              width: 80%;
              height: 80%;
              object-fit: contain;
            }
          }
        }

        &__num {
          margin-top: 3px;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 1px;
          white-space: nowrap;

          .el-icon-close {
            font-size: 9px;
            font-weight: bold;
          }
        }
      }
    }

    .card-action {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;

      .buy-btn {
        height: 38px;
        padding: 0 24px;
        border: 0;
        border-radius: 19px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        transition: opacity 0.15s, transform 0.15s;

        &:active:not(:disabled) {
          transform: scale(0.97);
        }

        &:disabled {
          opacity: 0.45;
          cursor: not-allowed;
        }
      }

      .limit-tag {
        font-size: 11px;
        padding: 1px 4px;
        border-radius: 3px;
        white-space: nowrap;
        line-height: 1.4;
      }
    }
  }

  &.is-mobile {
    &__content {
      padding: 12px 20px 20px;
    }

    .ticket-card {
      padding: 14px;

      .card-title {
        font-size: 14px;
        margin-bottom: 10px;
      }

      .card-items {
        gap: 8px;

        .card-item {
          &__icon {
            width: 44px;
            height: 44px;
            border-radius: 8px;
          }

          &__num {
            font-size: 11px;
            margin-top: 2px;
          }
        }
      }

      .card-action {
        .buy-btn {
          height: 34px;
          padding: 0 20px;
          font-size: 13px;
          border-radius: 17px;
        }
      }
    }
  }
}
</style>
